import classes from './submit-button.module.scss';
import logo from '../../../assets/icons/shield-logo.svg';

const SubmitBtn = (props) => {

  const  handleClick = () => {
    props.action();
  };

  return (
    <button
      type='button'
      id={props.id}
      className={classes.submit_btn}
      onClick={handleClick}
      disabled={props.disabled}
      ref={props.btnRef}
    >
      {props.showIcon ? (
        <span className={classes.icon_container} aria-hidden="true">
          <img src={logo}  />
        </span>
      ) : null}
      <span
        className={
          props.showIcon
            ? classes.label_container_icon
            : classes.label_container_noIcon
        }
      >
        {props.title}
      </span>
    </button>
  );

}
export default SubmitBtn;

